import React from 'react'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';
import ScaleLoader from "react-spinners/ScaleLoader";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faDownload } from '@fortawesome/free-solid-svg-icons'

import AppContext from '../../../AppContext.js';
import Submenu from '../../../components/submenu.js';
import SubmenuContent from './submenu.js';
import OffsetTop from '../../../components/offsetTop.js';

import {dateToInputFormat, dateToDatabaseFormat} from '../../../utils/datetime.js';

const localization = {
    ua: {
        title: 'Driver Feedback',
        site: 'Дилер',
        from: 'Від',
        to: 'До',
        lastMonth: 'Попередній місяць',
        currentWeek: 'Поточний тиждень',
        currentMonth: 'Поточний місяць',
        table: {
            workshop: 'Дилер',
            received: 'Потенціал',
            duplicates: 'Не придатно (дублі)',
            unknown: 'Не придатно (телефон)',
            quarantine: 'Не придатно (карантин)',
            useless: 'Не придатно (усього)',
            sent: 'Надіслано запитів',
            complete: 'Отримано відгуків',
            rate: 'Надали відповідь',
        }
    },
    ru: {
        title: 'Driver Feedback',
        site: 'Дилер',
        from: 'С',
        to: 'По',
        lastMonth: 'Предыдущий месяц',
        currentWeek: 'Текущая неделя',
        currentMonth: 'Текущий месяц',
        table: {
            workshop: 'Дилер',
            received: 'Потенциал',
            duplicates: 'Не пригодны (дубли)',
            unknown: 'Не пригодны (телефон)',
            quarantine: 'Не пригодны (карантин)',
            useless: 'Не пригодны (всего)',
            sent: 'Отправлено заявок',
            complete: 'Получено откликов',
            rate: 'Дали ответ',
        }
    },
    en: {
        title: 'Driver Feedback',
        site: 'Site',
        from: 'From',
        to: 'To',
        lastMonth: 'Last month',
        currentWeek: 'Current week',
        currentMonth: 'Current month',
        table: {
            workshop: 'Workshop',
            received: 'Sample received',
            duplicates: 'Not usable (duplicates)',
            unknown: 'Not usable (phone number)',
            quarantine: 'Not usable (quarantine)',
            useless: 'Not usable (total)',
            sent: 'Sample sent',
            complete: 'Complete',
            rate: 'Response rate',
        }
    },
}

class SampleSummary extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoadingSites: true,
            isLoadingSummary: true,

            sites: [],
            site: null,
            from: null,
            to: null,

            summary: null,
        }

        this.changeSite = this.changeSite.bind(this);
        this.changeFrom = this.changeFrom.bind(this);
        this.changeTo = this.changeTo.bind(this);

        this.changeLastMonth = this.changeLastMonth.bind(this);
        this.changeCurrentWeek = this.changeCurrentWeek.bind(this);
        this.changeCurrentMonth = this.changeCurrentMonth.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText} = this.context;
        setMenuExpandText(localization[lang].title);

        this.loadSites();
    }

    loadSites() {
        const {addNotification, removeNotification, token} = this.context;

        var site = localStorage.getItem("driver-feedback-site");
        var from = localStorage.getItem("driver-feedback-from");
        var to = localStorage.getItem("driver-feedback-to");

        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/crm/driver-feedback/sites', { token: token }).then((res) => {
                if (from == null || to == null) {
                    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                    from = new Date(y, m - 1, 1).getTime();//first day of prev month
                    to = new Date(y, m, 0).getTime();//last day of prev month
        
                    localStorage.setItem('driver-feedback-from', from);
                    localStorage.setItem('driver-feedback-to', to);
                }
        
                if (site == null || (res.data.rows.filter(e => e.id == site).length == 0)) {
                    localStorage.setItem('driver-feedback-site', res.data.rows[0].id);
                    site = res.data.rows[0].id;
                }

                this.setState({
                    isLoadingSites: false,
                    sites: res.data.rows, 
                    site: site,
                    from: Number(from),
                    to: Number(to),
                }, () => this.loadSummary());
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            if (from == null || to == null) {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                from = new Date(y, m - 1, 1).getTime();//first day of prev month
                to = new Date(y, m, 0).getTime();//last day of prev month
    
                localStorage.setItem('driver-feedback-from', from);
                localStorage.setItem('driver-feedback-to', to);
            }
    
            if (site == null) {
                localStorage.setItem('driver-feedback-site', 5);
            }

            this.setState({
                isLoadingSites: false,

                site: site,
                from: Number(from),
                to: Number(to),
                sites: [
                    {
                        id: "1",
                        name: "ВСЕ",
                    },
                    {
                        id: "-1",
                        name: "All Captive",
                    },
                    {
                        id: "-2",
                        name: "All Non-Captive",
                    },
                    {
                        id: "5",
                        name: "SCANIA Kiev",
                    },
                ]
            }, () => this.loadSummary());
        }
    }

    changeSite(event) {
        this.setState({site: event.target.value, isLoadingSummary: true}, () => {
            localStorage.setItem('driver-feedback-site', this.state.site);
            this.loadSummary();
        });
    }

    changeFrom(event) {
        this.setState({from: new Date(event.target.value).getTime(), isLoadingSummary: true}, () => {
            localStorage.setItem('driver-feedback-from', this.state.from);
            this.loadSummary();
        });
    }

    changeTo(event) {
        this.setState({to: new Date(event.target.value).getTime(), isLoadingSummary: true}, () => {
            localStorage.setItem('driver-feedback-to', this.state.to);
            this.loadSummary();
        });
    }

    changeLastMonth() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var from = new Date(y, m - 1, 1).getTime();//first day of prev month
        var to = new Date(y, m, 0).getTime();//last day of prev month

        this.setState({from: from, to: to, isLoadingSummary: true}, () => {
            localStorage.setItem('driver-feedback-from', from);
            localStorage.setItem('driver-feedback-to', to);
            this.loadSummary();
        });
    }

    changeCurrentWeek() {
        var date = new Date;

        var monday = date.getDate() - date.getDay() + 1;
        var sunday = monday + 6;

        var from = new Date(date.setDate(monday)).getTime();//first day of prev month
        var to = new Date(date.setDate(sunday)).getTime();//last day of prev month

        this.setState({from: from, to: to, isLoadingSummary: true}, () => {
            localStorage.setItem('driver-feedback-from', from);
            localStorage.setItem('driver-feedback-to', to);
            this.loadSummary();
        });
    }

    changeCurrentMonth() {
        var date = new Date(), y = date.getFullYear(), m = date.getMonth();

        var from = new Date(y, m, 1, 0, 0, 0).getTime();  //first day of current month
        var to = new Date(y, m+1, 0, 23, 59, 59).getTime();  //last day of current month

        this.setState({from: from, to: to, isLoadingActions: true}, () => {
            localStorage.setItem('driver-feedback-from', from);
            localStorage.setItem('driver-feedback-to', to);
            this.loadSummary();
        });
    }

    loadSummary() {
        const {addNotification, removeNotification, token} = this.context;

        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/crm/driver-feedback/sample-summary/summary', { token: token, site: this.state.site, from: dateToDatabaseFormat(this.state.from), to: dateToDatabaseFormat(this.state.to) }).then((res) => {
                this.setState({
                    isLoadingSummary: false,
                    summary: res.data.rows,
                });
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                isLoadingSummary: false,
                summary: [
                    {
                        workshop: "Kyiv",
                        received: "1007",
                        duplicates: "17",
                        unknown: "514",
                        quarantine: "184",
                        useless: "715",
                        sent: "292",
                        complete: "58",
                        rate: "20%",
                    },
                    {
                        workshop: "Lviv",
                        received: "857",
                        duplicates: "36",
                        unknown: "310",
                        quarantine: "201",
                        useless: "547",
                        sent: "310",
                        complete: "73",
                        rate: "24%",
                    },
                ]
            });
        }
    }

    render() {
        const {lang} = this.context;

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        return (
            <div>
                <DocumentMeta {...meta} />
                
                <Submenu>
                    <SubmenuContent />
                </Submenu>

                <br/><br/>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="container-fluid pb-4 mb-4">
                                <div className="row">
                                    <div className="col">
                                        <span>{localization[lang].site}:</span>
                                        <select className="question-input ml-1" style={{width: "220px"}} value={this.state.site + ""} onChange={this.changeSite}>
                                            {this.state.sites.map((item) => {
                                                return (
                                                    <option value={item.id}>{item.name}</option>
                                                )
                                            })}
                                        </select>

                                        <span className="ml-4">{localization[lang].from}:</span>
                                        <input type="date" className="question-input ml-1" style={{width: "220px"}} value={dateToInputFormat(this.state.from)} onChange={this.changeFrom} />

                                        <span className="ml-2">{localization[lang].to}:</span>
                                        <input type="date" className="question-input ml-1" style={{width: "220px"}} value={dateToInputFormat(this.state.to)} onChange={this.changeTo} />
                                        
                                        <button className="btn btn-link ml-4" onClick={this.changeLastMonth}>{localization[lang].lastMonth}</button>
                                        <button className="btn btn-link ml-2" onClick={this.changeCurrentWeek}>{localization[lang].currentWeek}</button>
                                        <button className="btn btn-link ml-2" onClick={this.changeCurrentMonth}>{localization[lang].currentMonth}</button>
                                    </div>
                                </div>
                            </div>

                            {!this.state.isLoadingSummary && (
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col">
                                            <table className="table table-bordered table-hover" style={{fontSize: "12px"}}>
                                                <thead>
                                                    <tr style={{backgroundColor: "#586981", color: "#fff"}}>
                                                        <th class="align-middle text-center">{localization[lang].table.workshop}</th>
                                                        <th class="align-middle text-center" style={{width: "160px"}}>{localization[lang].table.received}</th>
                                                        <th class="align-middle text-center" style={{width: "120px"}}>{localization[lang].table.duplicates}</th>
                                                        <th class="align-middle text-center" style={{width: "120px"}}>{localization[lang].table.unknown}</th>
                                                        <th class="align-middle text-center" style={{width: "120px"}}>{localization[lang].table.quarantine}</th>
                                                        <th class="align-middle text-center" style={{width: "120px"}}>{localization[lang].table.useless}</th>
                                                        <th class="align-middle text-center" style={{width: "140px"}}>{localization[lang].table.sent}</th>
                                                        <th class="align-middle text-center" style={{width: "100px"}}>{localization[lang].table.complete}</th>
                                                        <th class="align-middle text-center" style={{width: "100px"}}>{localization[lang].table.rate}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.summary.map((item) => {
                                                        return (
                                                            <tr>
                                                                <td class="align-middle pt-1 pb-1" style={{height: "40px"}}>{item.workshop}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.received}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.duplicates}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.unknown}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.quarantine}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.useless}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.sent}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.complete}</td>
                                                                <td class="align-middle text-center pt-1 pb-1">{item.rate}</td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SampleSummary;